import "@babel/polyfill";
import "core-js/stable";
import "regenerator-runtime/runtime";

import 'material-design-icons-iconfont/dist/material-design-icons.css?';
import 'vuetify/dist/vuetify.min.css'
import Vuetify from 'vuetify'
import Vuebar from 'vuebar';
import Vuex from 'vuex'
import Vue from 'vue'
import App from './App.vue'
import 'lodash';

Vue.config.productionTip = false;
Vue.config.useEslint = false;

Vue.use(Vuebar);
Vue.use(Vuetify);
Vue.use(Vuex);
require('typeface-roboto');

import store from './store/store.js';

const appColours = {
  primary: '#263746',
  gx_green: '#a1d0ca',
  secondary: '#a1d0ca',
  accent: '#d8d1ca',
  gx_beige: '#d8d1ca',
  error: '#FF5252',
  info: '#2196F3',
  success: '#4CAF50',
  warning: '#FFC107',
  gx_grey: '#e4e4e4',
  parishonline: '#01573C',
};

const vuetifyOpts = {
  icons: {
    iconfont: 'md',
  },
  theme: {
    dark: false,
    themes: {
      dark: appColours,
      light: appColours,
    },
  },
};

// if (process.env.NODE_ENV !== 'production') {
//   const VueAxe = require('vue-axe');
//   Vue.use(VueAxe, {
//     config: {
//       // ...
//       rules: [
//         { id: 'heading-order', enabled: true },
//         { id: 'label-title-only', enabled: true },
//         // and more
//       ]
//     }
//   })
// }

document.title = `Registration Form 1.1`;

new Vue({
  store,
  vuetify: new Vuetify(vuetifyOpts),
  render: h => h(App),
}).$mount('#app');
